<template>
    <main class="container_accueilmobile">
        <!-- ############### -->
        <!-- Section top -->

        <section class="container_accueilmobile__section_top">

            <!-- article top -->

            <article class="container_accueilmobile__section_top__article_top">
                <aside class="container_accueilmobile__section_top__article_top__aside_top">
                    <div class="container_accueilmobile__section_top__article_top__aside_top__div_title">
                        <h1 class="container_accueilmobile__section_top__article_top__aside_top__div_title__h1">
                            Développeur web
                        </h1>
                    </div>
                </aside>
                <!-- subtitle top -->
                <aside class="container_accueilmobile__section_top__article_top__aside_bottom">
                    <div class="container_accueilmobile__section_top__article_top__aside_bottom__div_subtitle">
                        <h2 class="container_accueilmobile__section_top__article_top__aside_bottom__div_subtitle__h2">
                            Compétences
                        </h2>
                    </div>
                    <!-- soulignage -->
                    <div class="container_accueilmobile__section_top__article_top__aside_bottom__div_vide">

                    </div>
                </aside>
            </article>

            <!-- article middle -->

            <article class="container_accueilmobile__section_top__article_middle">
                <swiper class="mySwiper">
                    <!-- angular -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_angular">
                            <div class="container_accueilmobile__section_top__article_middle__aside_angular__div">
                                <img src="@/assets/angularjs.png" alt="angular"
                                    class="container_accueilmobile__section_top__article_middle__aside_angular__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- vue -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_vue">
                            <div class="container_accueilmobile__section_top__article_middle__aside_vue__div">
                                <img src="@/assets/vue_icon.png" alt="vue_icon"
                                    class="container_accueilmobile__section_top__article_middle__aside_vue__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- react_icon -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_react">
                            <div class="container_accueilmobile__section_top__article_middle__aside_react__div">
                                <img src="@/assets/react_icon.png" alt="react_icon"
                                    class="container_accueilmobile__section_top__article_middle__aside_react__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- symfony -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_symfony">
                            <div class="container_accueilmobile__section_top__article_middle__aside_symfony__div">
                                <img src="@/assets/symfony.png" alt="symfony"
                                    class="container_accueilmobile__section_top__article_middle__aside_symfony__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- sql -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_sql">
                            <div class="container_accueilmobile__section_top__article_middle__aside_sql__div">
                                <img src="@/assets/sql.png" alt="sql"
                                    class="container_accueilmobile__section_top__article_middle__aside_sql__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- html -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_html">
                            <div class="container_accueilmobile__section_top__article_middle__aside_html__div">
                                <img src="@/assets/social_html5.png" alt="social_html5"
                                    class="container_accueilmobile__section_top__article_middle__aside_html__div">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- css3 -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_css">
                            <div class="container_accueilmobile__section_top__article_middle__aside_css__div">
                                <img src="@/assets/css3.png" alt="css3"
                                    class="container_accueilmobile__section_top__article_middle__aside_css__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- javascript -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_javascript">
                            <div class="container_accueilmobile__section_top__article_middle__aside_javascript__div">
                                <img src="@/assets/javascript_logo_icon.png" alt="javascript_logo_icon"
                                    class="container_accueilmobile__section_top__article_middle__aside_javascript__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- php -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_php">
                            <div class="container_accueilmobile__section_top__article_middle__aside_php__div">
                                <img src="@/assets/php.png" alt="PHP"
                                    class="container_accueilmobile__section_top__article_middle__aside_php__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- python -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_top__article_middle__aside_python">
                            <div class="container_accueilmobile__section_top__article_middle__aside_python__div">
                                <img src="@/assets/Python.png" alt="Python"
                                    class="container_accueilmobile__section_top__article_middle__aside_python__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                </swiper>
            </article>

            <!-- article bottom -->

            <article class="container_accueilmobile__section_top__article_bottom">
                <aside class="container_accueilmobile__section_top__article_bottom__aside">
                    <button class="container_accueilmobile__section_top__article_bottom__aside__button">
                        <router-link to="/services#web"
                            class="container_accueilmobile__section_top__article_bottom__aside__button__router-link">
                            Prestations
                        </router-link>
                    </button>
                </aside>
            </article>
        </section>
        <!-- ############### -->
        <!-- Section middle -->
        <section>
            <!-- article top -->

            <article class="container_accueilmobile__section_middle__article_top">
                <aside class="container_accueilmobile__section_middle__article_top__aside_top">
                    <div class="container_accueilmobile__section_middle__article_top__aside_top__div_title">
                        <h1 class="container_accueilmobile__section_middle__article_top__aside_top__div_title__h1">
                            Dessinateur industriel
                        </h1>
                        <!-- text after -->
                        <p class="container_accueilmobile__section_middle__article_top__aside_top__div_title__p">
                            Etude et definition
                        </p>
                    </div>
                </aside>
                <!-- subtitle top -->
                <aside class="container_accueilmobile__section_middle__article_top__aside_bottom">
                    <div class="container_accueilmobile__section_middle__article_top__aside_bottom__div_subtitle">
                        <h2 class="container_accueilmobile__section_middle__article_top__aside_bottom__div_subtitle__h2">
                            Compétences
                        </h2>
                    </div>
                    <!-- soulignage -->
                    <div class="container_accueilmobile__section_middle__article_top__aside_bottom__div_vide">

                    </div>
                </aside>
            </article>

            <!-- article middle -->

            <article class="container_accueilmobile__section_middle__article_middle">
                <swiper class="mySwiper">
                    <!-- solidworks -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_middle__article_middle__aside_solidworks">
                            <div class="container_accueilmobile__section_middle__article_middle__aside_solidworks__div">
                                <img src="@/assets/solidworks_icon-icons.com.png" alt="solidworks"
                                    class="container_accueilmobile__section_middle__article_middle__aside_solidworks__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- conception industriel -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_middle__article_middle__aside_edpi">
                            <div class="container_accueilmobile__section_middle__article_middle__aside_edpi__div">
                                <img src="@/assets/pencil-write.png" alt="pencil"
                                    class="container_accueilmobile__section_middle__article_middle__aside_edpi__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- plan -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_middle__article_middle__aside_sheet">
                            <div class="container_accueilmobile__section_middle__article_middle__aside_sheet__div">
                                <img src="@/assets/real_estate.png" alt="real_estate"
                                    class="container_accueilmobile__section_middle__article_middle__aside_sheet__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                </swiper>
            </article>

            <!-- article bottom -->

            <article class="container_accueilmobile__section_middle__article_bottom">
                <aside class="container_accueilmobile__section_middle__article_bottom__aside">
                    <button class="container_accueilmobile__section_middle__article_bottom__aside__button">
                        <router-link to="/services#industriel"
                            class="container_accueilmobile__section_middle__article_bottom__aside__button__router-link">
                            Prestations
                        </router-link>
                    </button>
                </aside>
            </article>
        </section>
        <!-- ############### -->
        <!-- Section bottom -->
        <section>
            <!-- article top -->

            <article class="container_accueilmobile__section_bottom__article_top">
                <aside class="container_accueilmobile__section_bottom__article_top__aside_top">
                    <div class="container_accueilmobile__section_bottom__article_top__aside_top__div_title">
                        <h1 class="container_accueilmobile__section_bottom__article_top__aside_top__div_title__h1">
                            Dessinateur industriel
                        </h1>
                        <!-- text after -->
                        <p class="container_accueilmobile__section_bottom__article_top__aside_top__div_title__p">
                            Etude et definition
                        </p>
                    </div>
                </aside>
                <!-- subtitle top -->
                <aside class="container_accueilmobile__section_bottom__article_top__aside_bottom">
                    <div class="container_accueilmobile__section_bottom__article_top__aside_bottom__div_subtitle">
                        <h2 class="container_accueilmobile__section_bottom__article_top__aside_bottom__div_subtitle__h2">
                            Compétences
                        </h2>
                    </div>
                    <!-- soulignage -->
                    <div class="container_accueilmobile__section_bottom__article_top__aside_bottom__div_vide">

                    </div>
                </aside>
            </article>

            <!-- article middle -->

            <article class="container_accueilmobile__section_bottom__article_middle">
                <swiper class="mySwiper">
                    <!-- soldier -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_bottom__article_middle__aside_soldier">
                            <div class="container_accueilmobile__section_bottom__article_middle__aside_soldier__div">
                                <img src="@/assets/soldier.png" alt="soldier"
                                    class="container_accueilmobile__section_bottom__article_middle__aside_soldier__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- instructeur de tir -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_bottom__article_middle__aside_pistol">
                            <div class="container_accueilmobile__section_bottom__article_middle__aside_pistol__div">
                                <img src="@/assets/gun-pistol.png" alt="pistol"
                                    class="container_accueilmobile__section_bottom__article_middle__aside_pistol__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                    <!-- defense -->
                    <swiper-slide>
                        <aside class="container_accueilmobile__section_bottom__article_middle__aside_defense">
                            <div class="container_accueilmobile__section_bottom__article_middle__aside_defense__div">
                                <img src="@/assets/defense.png" alt="defense"
                                    class="container_accueilmobile__section_bottom__article_middle__aside_defense__div__img">
                            </div>
                        </aside>
                    </swiper-slide>
                </swiper>
            </article>

            <!-- article bottom -->

            <article class="container_accueilmobile__section_bottom__article_bottom">
                <aside class="container_accueilmobile__section_bottom__article_bottom__aside">
                    <button class="container_accueilmobile__section_bottom__article_bottom__aside__button">
                        <router-link to="/services#tir"
                            class="container_accueilmobile__section_bottom__article_bottom__aside__button__router-link">
                            Prestations
                        </router-link>
                    </button>
                </aside>
            </article>
        </section>
    </main>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper";
export default {
    name: 'AccueilMobile',

    components: {
        Swiper,
        SwiperSlide,
    },

    setup() {
        return {
            modules: [Pagination],
        };
    },
};

</script>

<style lang=scss scoped>

//@import "@/style/components/accueil/AccueilMobile.scss";
@import "@/style/color.scss";
@import "@/style/effets.scss";

.container_accueilmobile {
    background-color: $BG;
    margin: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &__section_top {
        width: 100vw;
        margin: auto;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        &__article_top {
            margin: auto;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            &__aside_top {
                margin-left: auto;
                margin-right: auto;
                border: solid 0.25rem white;
                border-radius: 1rem;
                width: 20rem;
                height: 4rem;
                margin-top: 2vh;

                // #################################
                &__div_title {
                    text-align: center;

                    &__h1 {
                        font-size: $h1;
                        font-weight: normal;
                        margin: auto;
                    }
                }
            }

            // subtitle top

            &__aside_bottom {
                margin: auto;

                &__div_subtitle {
                    text-align: center;

                    &__h2 {
                        font-size: $text;
                    }
                }

                &__div_vide {
                    margin-left: auto;
                    margin-right: auto;
                    width: 9rem;
                    height: 0.25rem;
                    background-color: white;
                    border-radius: 1rem;
                    position: relative;
                    bottom: 1rem;
                }
            }
        }

        // article middle

        &__article_middle {
            width: 100vw;
            margin-left: auto;
            margin-right: auto;
            overflow: hidden;
            margin-top: 2rem;

            &__aside_angular {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            // vue

            &__aside_vue {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_react {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_sql {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_symfony {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_html {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_css {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_javascript {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_php {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_python {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }
        }

        //##################
        // article bottom

        &__article_bottom {
            margin-left: auto;
            margin-right: auto;
            margin-top: 2rem;

            &__aside {
                margin: auto;

                &__button {
                    width: $card-size;
                    height: 4rem;
                    background-color: $RV;
                    border: none;
                    border-radius: 2rem;

                    &__router-link {
                        font-size: $text;
                        color: white;
                    }
                }
            }
        }
    }

    //######################

    // section middle

    //######################

    &__section_middle {
        display: flex;
        flex-direction: column;

        &__article_top {
            display: flex;
            flex-direction: column;

            &__aside_top {
                margin-left: auto;
                margin-right: auto;
                border: solid 0.25rem white;
                border-radius: 1rem;
                width: 20rem;
                height: 4rem;
                margin-top: 2vh;

                &__div_title {
                    text-align: center;

                    &__h1 {
                        font-size: $h1;
                        font-weight: normal;
                        margin: auto;
                    }

                    &__h1:after {
                        display: none;
                    }

                    // after

                    &__p {
                        font-size: $text;
                        display: none;
                        margin: auto;
                    }

                    &__p:after {
                        display: block;
                    }
                }
            }

            // aside bottom

            &__aside_bottom {
                margin-left: auto;
                margin-right: auto;

                &__div_subtitle {
                    text-align: center;

                    &__h2 {
                        font-size: $text;
                    }
                }

                // div vide

                &__div_vide {
                    margin-left: auto;
                    margin-right: auto;
                    width: 9rem;
                    height: 0.25rem;
                    background-color: white;
                    border-radius: 1rem;
                    position: relative;
                    bottom: 1rem;
                }
            }
        }

        // ##################

        // article middle

        &__article_middle {
            //margin-left: auto;
            //margin-right: auto;
            overflow: hidden;
            margin-top: 2rem;

            &__aside_solidworks {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            // edpi

            &__aside_edpi {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_sheet {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }
        }

        //##################
        // article bottom

        &__article_bottom {
            margin-left: auto;
            margin-right: auto;
            margin-top: 2rem;

            &__aside {
                margin: auto;
                width: $card-size;

                &__button {
                    width: $card-size;
                    height: 4rem;
                    background-color: $RV;
                    border: none;
                    border-radius: 2rem;

                    &__router-link {
                        font-size: $text;
                        color: white;
                    }
                }
            }
        }
    }

    //######################

    // section bottom

    //######################

    &__section_bottom {
        display: flex;
        flex-direction: column;

        &__article_top {
            display: flex;
            flex-direction: column;

            &__aside_top {
                margin-left: auto;
                margin-right: auto;
                border: solid 0.25rem white;
                border-radius: 1rem;
                width: 20rem;
                height: 4rem;
                margin-top: 2vh;

                &__div_title {
                    text-align: center;

                    &__h1 {
                        font-size: $h1;
                        font-weight: normal;
                        margin: auto;
                    }

                    &__h1:after {
                        display: none;
                    }

                    // after

                    &__p {
                        font-size: $text;
                        display: none;
                        margin: auto;
                    }

                    &__p:after {
                        display: block;
                    }
                }
            }

            // aside bottom

            &__aside_bottom {
                margin-left: auto;
                margin-right: auto;

                &__div_subtitle {
                    text-align: center;

                    &__h2 {
                        font-size: $text;
                    }
                }

                // div vide

                &__div_vide {
                    margin-left: auto;
                    margin-right: auto;
                    width: 9rem;
                    height: 0.25rem;
                    background-color: white;
                    border-radius: 1rem;
                    position: relative;
                    bottom: 1rem;
                }
            }
        }

        // ##################

        // article middle

        &__article_middle {
            //margin-left: auto;
            //margin-right: auto;
            overflow: hidden;
            margin-top: 2rem;

            &__aside_soldier {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            // edpi

            &__aside_pistol {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }

            &__aside_defense {
                margin-left: auto;
                margin-right: auto;
                box-shadow: $ombres;
                height: $card-size;
                width: $card-size;
                overflow: hidden;
                background-color: white;

                &__div {
                    margin: auto;
                    height: $card-size;
                    width: $card-size;

                    &__img {
                        margin-bottom: 10vw;
                        margin-top: 10vw;
                        margin-right: 10vw;
                        margin-left: 10vw;
                        width: $icon-size;
                        height: $icon-size;
                    }
                }
            }
        }

        //##################
        // article bottom

        &__article_bottom {
            margin-left: auto;
            margin-right: auto;
            margin-top: 2rem;

            &__aside {
                margin: auto;
                width: $card-size;

                &__button {
                    width: $card-size;
                    height: 4rem;
                    background-color: $RV;
                    border: none;
                    border-radius: 2rem;

                    &__router-link {
                        font-size: $text;
                        color: white;
                    }
                }
            }
        }
    }
}

.swiper-slide {
    background-color: $BG;
}

@media screen and(min-width: 926px) {
    .container_accueilmobile {
        display: none;
    }
}
</style>
